module.exports = {
  "testing" : "this is a testing string"
}